module.exports = __webpack_public_path__ + "static/media/domain.e8e4ce23.png";